import makeStyles from "@mui/styles/makeStyles";
import { styled } from "@mui/material/styles";
import Button from "Components/Form/Button";

export const StyledButton = styled(Button)({
  padding: "10px 20px 10px 16px",
  width: 140,
});

const styles = makeStyles(() => ({
  minHeight500: {
    minHeight: 500,
  },
  volumeContainer: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    padding: "4px 12px",
    gap: "10px",
    border: "1px solid #E4E7EC",
    borderRadius: "8px",
    fontFamily: "Inter",
    fontStyle: "normal",
    fontWeight: 600,
    fontSize: "18px",
    lineHeight: "24px",
    color: "#9CA6AF",
    height: "40px",
  },
  volumeTitle: {
    color: "#465869",
    fontWeight: 700,
  },
  addOrderButton: {
    whiteSpace: "nowrap",
    color: "#FFFFFF !important",
    padding: "10px 20px 10px 16px",
  },
  button: {
    cursor: "pointer",
  },
  buttonOff: {
    cursor: "auto",
    "& svg": {
      color: "rgba(	71, 84, 103, 0.5) !important",
    },
  },
  containerLocation: {
    maxWidth: "150px",
  },
  cancelModalContainer: {
    width: "100%",
  },
  descriptionModalConfirm: {
    display: "flex",
    gap: "0.7rem",
    alignItems: "flex-start",
    justifyContent: "flex-start",
    flexDirection: "column",
    "& span": {
      fontFamily: "Inter",
      fontStyle: "normal",
      fontWeight: "400",
      fontSize: "16px",
      lineHeight: "24px",
    },
    "& .error": {
      color: "#F04438",
      fontStyle: "italic",
    },
  },
  mt20: {
    marginTop: 20,
  },
}));

export default styles;
